"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var HotSpotList_1 = require("./HotSpotList");
function createHotSpot(children, moduleParams, timeDelay) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            var params = typeof moduleParams === 'function' ? moduleParams(props) : moduleParams;
            var delayTime = timeDelay && timeDelay(props);
            try {
                HotSpotList_1.hotSpotList.add(_this, params, delayTime ? delayTime.timeDelay : undefined);
            }
            catch (error) { }
            return _this;
        }
        class_1.prototype.render = function () {
            return react_1.default.createElement(children, this.props);
        };
        return class_1;
    }(react_1.default.Component));
}
exports.default = createHotSpot;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@weike/operation-report/dist/components/HotSpot/createHotSpot.js
// module id = 380
// module chunks = 0